import { SUPPORTED_LANGUAGES } from '../constants';
export const getLanguagePathPrefix = (language = '') => {
    const langAbbr = SUPPORTED_LANGUAGES[language];
    return langAbbr && langAbbr !== 'en' ? `/${langAbbr}` : '';
};
//# sourceMappingURL=getLanguagePathPrefix.js.map